<template>
	<div>
		<vxe-table  align="center" :data="list"  border max-height="600" ref="mTable" show-overflow="title" size="mini"
						  :loading="loading" row-id="PID" :cell-style="cellClassName">
				<vxe-table-column type="seq" width="60"></vxe-table-column>
				<vxe-table-column title="抄表读数" field="resultData" ></vxe-table-column>
				<vxe-table-column title="抄表时间" field="createTime" width="150"></vxe-table-column>
		</vxe-table>
	</div>
</template>

<script>
	export default{
		props:[
			'theId',
		],
		data(){
			return {
				list:[],
				loading:true,
			}
		},
		methods:{
			cellClassName({ row, rowIndex, column }){
				let style = null;
				if(row.resultDesc=='人工修改'){
					 style =  {
						 backgroundColor: '#f0f9eb',
						 color: '#000',
						 fontFamily:"arial,sans-serif",
					 }
				}
				return style;
			},
			queryDataList:function(){
				this.loading = true;
				let url = this.Api.getLastUrl(this.Api.READ_METER_HISTORY_URL);
				let param = {meterId:this.theId};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.loading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.list = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.loading = false;
					console.log(error);
				});
			},
			getFormatter:function(dateTime){
				if(dateTime!=null){
					let date = new Date(dateTime);
					console.log(date);
					return this.Config.formatDate(date);
				}else{
					return "";
				}
				
			},
		},
		created() {
			this.queryDataList();
		}
	}
</script>

<style>
</style>
